import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PageEvent } from '@angular/material/paginator';
import { InspecaoRepository } from '@app/data/inspecoes/inspecao.repository';
import { InspecaoImpressaoModel, InspecaoModeloImpressaoModel, InspecaoModel } from '@app/data/inspecoes/models';
import { modal } from '@app/shared/alerts/modal/modal.alert';
import { base64ToBlob } from '@app/shared/routines';

export interface ModalModelosImpressaoData {
  inspecao: InspecaoModel;
  modelos: InspecaoModeloImpressaoModel[];
}

@Component({
  selector: 'app-modal-modelos-impressao',
  templateUrl: './modal-modelos-impressao.component.html',
  styleUrls: ['./modal-modelos-impressao.component.scss'],
})
export class ModalModelosImpressaoComponent implements OnInit {
  public modeloSelecionadoId: string = '';
  public loading: boolean = false;
  public pageSize: number = 10;
  public pageIndex: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalModelosImpressaoData,
    private dialogRef: MatDialogRef<ModalModelosImpressaoComponent>,
    private inspecaoRepository: InspecaoRepository,
    private snack: MatSnackBar,
  ) {}

  public ngOnInit(): void {
    if (this.data?.modelos && this.data.modelos.length > 0) {
      this.modeloSelecionadoId = this.data.modelos[0].CodigoInspecaoModeloImpressao;
    }
  }

  public get modelosExibidos(): InspecaoModeloImpressaoModel[] {
    if (!this.data?.modelos) return [];
    const start = this.pageIndex * this.pageSize;
    return this.data.modelos.slice(start, start + this.pageSize);
  }

  public onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  public fechar(): void {
    if (!this.loading) {
      this.dialogRef.close(false);
    }
  }

  public selecionarModelo(codigoModelo: string): void {
    if (!this.loading) {
      this.modeloSelecionadoId = codigoModelo;
    }
  }

  public imprimir(): void {
    if (!this.modeloSelecionadoId || !this.data?.inspecao?.CodigoInspecao) {
      this.snack.open('Selecione um modelo de impressão', undefined, {
        duration: 4000,
      });
      return;
    }

    this.loading = true;
    this.inspecaoRepository
      .imprimirFicha({
        CodigoInspecao: String(this.data.inspecao.CodigoInspecao),
        CodigoInspecaoModeloImpressao: String(this.modeloSelecionadoId),
        TipoTemplateInspecao: 'P',
      })
      .subscribe({
        next: (response: any) => {
          const data: InspecaoImpressaoModel = response?.data || response;
          if (data && data.content) {
            const file = base64ToBlob(data.content, 'application/pdf');
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
            this.dialogRef.close(true);
          } else {
            this.snack.open('Ficha de inspeção inválida', undefined, {
              duration: 4000,
            });
          }
        },
        error: (error) => {
          modal.fire({
            icon: error?.icon || 'error',
            title: error?.title || 'Erro ao imprimir',
            html: error?.message || 'Não foi possível imprimir a ficha da inspeção.',
          });
        },
      })
      .add(() => {
        this.loading = false;
      });
  }
}
